// Module
var code = `<button
        class="login-btn blue-border"
        aria-label="Log in"
        data-type="auth0"
        data-is-gated="false"
        data-event-prevent-default="true"
        data-event-type="login"
        id="login"
>
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <circle cx="12" cy="8" r="4"/>
        <path d="M4 21v-1a8 8 0 0 1 16 0v1"/>
    </svg>
</button>
`;
// Exports
module.exports = code;